import * as React from "react";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Link,
  MenuItem,
  Paper,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";

// ✅ your stores + API (using the new setTokens)
import { useUserStore } from "../../store/userStore";
import { useCartStore } from "../../store/cartStore";
import { useVendorStore } from "../../store/vendorStore";
import { userApi } from "../../apiServices/UserApiService";

const countryOptions = [
  { code: "AF", name: "Afghanistan" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AS", name: "American Samoa" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AQ", name: "Antarctica" },
  { code: "AG", name: "Antigua and Barbuda" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AW", name: "Aruba" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia" },
  { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BV", name: "Bouvet Island" },
  { code: "BR", name: "Brazil" },
  { code: "IO", name: "British Indian Ocean Territory" },
  { code: "BN", name: "Brunei Darussalam" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "CV", name: "Cabo Verde" },
  { code: "KH", name: "Cambodia" },
  { code: "CM", name: "Cameroon" },
  { code: "CA", name: "Canada" },
  { code: "KY", name: "Cayman Islands" },
  { code: "CF", name: "Central African Republic" },
  { code: "TD", name: "Chad" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CX", name: "Christmas Island" },
  { code: "CC", name: "Cocos (Keeling) Islands" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comoros" },
  { code: "CG", name: "Congo" },
  { code: "CD", name: "Congo (Democratic Republic)" },
  { code: "CK", name: "Cook Islands" },
  { code: "CR", name: "Costa Rica" },
  { code: "CI", name: "Côte d'Ivoire" },
  { code: "HR", name: "Croatia" },
  { code: "CU", name: "Cuba" },
  { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czechia" },
  { code: "DK", name: "Denmark" },
  { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" },
  { code: "DO", name: "Dominican Republic" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "GQ", name: "Equatorial Guinea" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini" },
  { code: "ET", name: "Ethiopia" },
  { code: "FK", name: "Falkland Islands" },
  { code: "FO", name: "Faroe Islands" },
  { code: "FJ", name: "Fiji" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "GF", name: "French Guiana" },
  { code: "PF", name: "French Polynesia" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" },
  { code: "GH", name: "Ghana" },
  { code: "GI", name: "Gibraltar" },
  { code: "GR", name: "Greece" },
  { code: "GL", name: "Greenland" },
  { code: "GD", name: "Grenada" },
  { code: "GP", name: "Guadeloupe" },
  { code: "GU", name: "Guam" },
  { code: "GT", name: "Guatemala" },
  { code: "GG", name: "Guernsey" },
  { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" },
  { code: "HM", name: "Heard Island and McDonald Islands" },
  { code: "VA", name: "Holy See" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong" },
  { code: "HU", name: "Hungary" },
  { code: "IS", name: "Iceland" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Ireland" },
  { code: "IM", name: "Isle of Man" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JE", name: "Jersey" },
  { code: "JO", name: "Jordan" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" },
  { code: "KP", name: "North Korea" },
  { code: "KR", name: "South Korea" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" },
  { code: "LA", name: "Laos" },
  { code: "LV", name: "Latvia" },
  { code: "LB", name: "Lebanon" },
  { code: "LS", name: "Lesotho" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libya" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  { code: "MO", name: "Macao" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldives" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MH", name: "Marshall Islands" },
  { code: "MQ", name: "Martinique" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" },
  { code: "YT", name: "Mayotte" },
  { code: "MX", name: "Mexico" },
  { code: "FM", name: "Micronesia" },
  { code: "MD", name: "Moldova" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MS", name: "Montserrat" },
  { code: "MA", name: "Morocco" },
  { code: "MZ", name: "Mozambique" },
  { code: "MM", name: "Myanmar" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Netherlands" },
  { code: "NC", name: "New Caledonia" },
  { code: "NZ", name: "New Zealand" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NU", name: "Niue" },
  { code: "NF", name: "Norfolk Island" },
  { code: "MK", name: "North Macedonia" },
  { code: "MP", name: "Northern Mariana Islands" },
  { code: "NO", name: "Norway" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PS", name: "Palestine" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua New Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PN", name: "Pitcairn" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "PR", name: "Puerto Rico" },
  { code: "QA", name: "Qatar" },
  { code: "RE", name: "Réunion" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russia" },
  { code: "RW", name: "Rwanda" },
  { code: "BL", name: "Saint Barthélemy" },
  { code: "SH", name: "Saint Helena" },
  { code: "KN", name: "Saint Kitts and Nevis" },
  { code: "LC", name: "Saint Lucia" },
  { code: "MF", name: "Saint Martin" },
  { code: "PM", name: "Saint Pierre and Miquelon" },
  { code: "VC", name: "Saint Vincent and the Grenadines" },
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "ST", name: "Sao Tome and Principe" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SX", name: "Sint Maarten" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "SB", name: "Solomon Islands" },
  { code: "SO", name: "Somalia" },
  { code: "ZA", name: "South Africa" },
  { code: "GS", name: "South Georgia and the South Sandwich Islands" },
  { code: "SS", name: "South Sudan" },
  { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SJ", name: "Svalbard and Jan Mayen" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "SY", name: "Syria" },
  { code: "TW", name: "Taiwan" },
  { code: "TJ", name: "Tajikistan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TH", name: "Thailand" },
  { code: "TL", name: "Timor-Leste" },
  { code: "TG", name: "Togo" },
  { code: "TK", name: "Tokelau" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad and Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Turkey" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TC", name: "Turks and Caicos Islands" },
  { code: "TV", name: "Tuvalu" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "UM", name: "United States Minor Outlying Islands" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  { code: "VG", name: "Virgin Islands (British)" },
  { code: "VI", name: "Virgin Islands (U.S.)" },
  { code: "WF", name: "Wallis and Futuna" },
  { code: "EH", name: "Western Sahara" },
  { code: "YE", name: "Yemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
];

export default function SunsetLoginMUI() {
  const navigate = useNavigate();
  const basePath = process.env.REACT_APP_BASE_NAME || "";
  
  const setTokens = useUserStore((s) => s.setTokens);
  const addVendor = useVendorStore((s) => s.addVendor);

  // form state
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [requestAccessOpen, setRequestAccessOpen] = React.useState(false);
  const [requestAccessLoading, setRequestAccessLoading] = React.useState(false);
  const [vendorName, setVendorName] = React.useState("");
  const [contactEmail, setContactEmail] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [countryCode, setCountryCode] = React.useState("");

  // snackbar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState<"success" | "error">("error");

  const handleTogglePassword = () => setShowPassword((p) => !p);
  const handleCloseSnackbar = (_e?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  const resetRequestAccessForm = () => {
    setVendorName("");
    setContactEmail("");
    setPhoneNumber("");
    setCountryCode("");
  };

  const validateRequestAccess = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^\+?[0-9\s().-]{7,15}$/;

    if (!vendorName.trim()) {
      setSnackbarMessage("Vendor name is required.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return false;
    }

    if (!contactEmail.trim()) {
      setSnackbarMessage("Contact email is required.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return false;
    }

    if (!emailPattern.test(contactEmail.trim())) {
      setSnackbarMessage("Please enter a valid email address.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return false;
    }

    if (!phoneNumber.trim()) {
      setSnackbarMessage("Phone number is required.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return false;
    }

    if (!phonePattern.test(phoneNumber.trim())) {
      setSnackbarMessage("Please enter a valid phone number.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return false;
    }

    if (!countryCode.trim()) {
      setSnackbarMessage("Country is required.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return false;
    }

    return true;
  };

  const handleRequestAccess = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!validateRequestAccess()) {
      return;
    }

    try {
      setRequestAccessLoading(true);
      await addVendor({
        vendorName: vendorName.trim(),
        contactEmail: contactEmail.trim(),
        phoneNumber: phoneNumber.trim(),
        address: null,
        countryCode: countryCode.trim(),
      });

      setSnackbarMessage("Your access request has been submitted successfully.");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      setRequestAccessOpen(false);
      resetRequestAccessForm();
    } catch (error: any) {
      console.error("❌ Request access error:", error);
      setSnackbarMessage(error?.message || "Unable to submit your access request.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setRequestAccessLoading(false);
    }
  };

  const handleLogin = async () => {
    if (!email || !password) {
      setSnackbarMessage("Please enter both email and password.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }
    try {
      setLoading(true);
      console.log("basePath....",basePath)
      const oem = basePath.split("/")[1];
      console.log("oem....",oem)
      const { token, refreshToken } = await userApi.login({ email, password, oem });
        console.log("handle kogin triggered...")
      // ✅ single call does tokens + user decode + persist
      setTokens(token, refreshToken);

      // init cart
      await useCartStore.getState().initOnLogin();

      setSnackbarMessage("Login successful!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      navigate("/dashboard");
    } catch (error: any) {
      console.error("❌ Login error:", error);
      setSnackbarMessage(error?.response?.data?.message || "Login failed.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  // background
  const publicBase = process.env.PUBLIC_URL || "";
  const backgroundUrl = `${publicBase}/sunset.jpg`; // swap to .png if needed
  const logoTextColor = "#ffcdb8";

  // (Optional) If you still want the company name from base path:
 // const basePath = process.env.REACT_APP_BASE_NAME || "";
  const pathParts = basePath.split("/");
  const companyName = pathParts[1] || "Parts Catalog";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 2, md: 4 },
      }}
    >
      {/* background layer */}
      <Box aria-hidden sx={{ position: "absolute", inset: 0, zIndex: 0, overflow: "hidden" }}>
        <Box
          component="img"
          src={backgroundUrl}
          alt=""
          sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(0,0,0,.45), rgba(0,0,0,.15) 35%, rgba(0,0,0,.05))",
            pointerEvents: "none",
          }}
        />
      </Box>

      {/* foreground content */}
      <Container maxWidth="lg" disableGutters sx={{ position: "relative", zIndex: 1 }}>
        <Paper
          elevation={24}
          className="hover-card"
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: 4,
            backdropFilter: "blur(6px)",
            bgcolor: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.18)",
          }}
        >
          {/* keep row so swap is visible at all widths */}
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            {/* LEFT — form */}
            <Box
              className="panel-left"
              sx={{
                flex: "0 0 50%",
                maxWidth: "50%",
                minWidth: 0,
                p: { xs: 3, md: 6 },
                bgcolor: "rgba(255,255,255,0.78)",
                backdropFilter: "blur(8px)",
                position: "relative",
                willChange: "transform",
                transition: "transform 480ms cubic-bezier(0.2, 0.6, 0.2, 1)",
                transform: "translateX(0%)",
                zIndex: 2,
                // 🔥 SWAP: on hover, left goes RIGHT by 100% of its own width
                ".hover-card:hover &": {
                  transform: "translateX(100%) !important",
                },
              }}
            >
              <Typography variant="h4" fontWeight={700} color="text.primary">
                Welcome back
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Sign in to access
              </Typography>

              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleLogin();
                }}
                sx={{ mt: 5, display: "grid", gap: 2.5 }}
              >
                <TextField
                  label="Email"
                  type="email"
                  placeholder="you@company.com"
                  autoComplete="email"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlinedIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label={showPassword ? "Hide password" : "Show password"}
                          onClick={handleTogglePassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <FormControlLabel control={<Checkbox color="primary" />} label="Remember me" />
                  <Link
                    component="button"
                    type="button"
                    onClick={() => navigate("/forgot-password")}
                    underline="hover"
                    color="primary"
                  >
                    Forgot password?
                  </Link>
                </Box>

                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => setRequestAccessOpen(true)}
                  sx={{
                    py: 1.1,
                    borderRadius: 2,
                    fontWeight: 700,
                    textTransform: "none",
                  }}
                >
                  Request Access
                </Button>

                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  disabled={loading}
                  sx={{
                    py: 1.25,
                    borderRadius: 2,
                    fontWeight: 700,
                    textTransform: "none",
                    background: (theme) =>
                      `linear-gradient(90deg, ${theme.palette.primary.main}, #db2777, #fb7185)`,
                    boxShadow: "0 10px 30px rgba(79,70,229,.35)",
                    ":hover": { boxShadow: "0 16px 36px rgba(79,70,229,.45)" },
                  }}
                >
                  {loading ? "Logging in..." : "Sign in"}
                </Button>
              </Box>
            </Box>

            {/* RIGHT — welcome + logos */}
            <Box
              className="panel-right"
              sx={{
                position: "relative",
                flex: "0 0 50%",
                maxWidth: "50%",
                minWidth: 0,
                color: logoTextColor,
                p: { xs: 3, md: 6 },
                willChange: "transform",
                transition: "transform 480ms cubic-bezier(0.2, 0.6, 0.2, 1)",
                transform: "translateX(0%)",
                zIndex: 1,
                // 🔥 SWAP: on hover, right goes LEFT by 100% of its own width
                ".hover-card:hover &": {
                  transform: "translateX(-100%) !important",
                },
              }}
            >
              {/* subtle glass overlay */}
              <Box
                sx={{
                  position: "absolute",
                  inset: { xs: 12, md: 16 },
                  borderRadius: 3,
                  bgcolor: "rgba(255,255,255,0.06)",
                  border: "none",
                  backdropFilter: "blur(2px)",
                  pointerEvents: "none",
                }}
              />
              <Box
                sx={{
                  position: "relative",
                  zIndex: 1,
                  minHeight: { md: 360 },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: 2,
                  "& .MuiTypography-root": {
                    color: logoTextColor,
                    textShadow: "0 0 10px rgba(255, 140, 112, 0.45), 0 2px 10px rgba(0,0,0,.28)",
                  },
                }}
              >
                {/* <Typography variant="overline" sx={{ letterSpacing: 6, color: "rgba(255,255,255,.85)" }}>
                  Welcome
                </Typography> */}
                <Typography
                  variant="h6"
                  fontWeight={700}
                  sx={{
                    fontSize: { xs: "1.5rem", sm: "1.7rem", md: "1.85rem", lg: "2rem" },
                    lineHeight: 2.00,
                    whiteSpace: { xs: "normal", md: "nowrap" },
                    letterSpacing: "0.015em",
                    fontFamily: '"Georgia", "Times New Roman", serif',
                    fontStyle: "italic",
                    transform: "skewX(-4deg)",
                    transformOrigin: "left center",
                  }}
                >
                  niAuthor platforms
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    maxWidth: 580,
                    display: "inline-block",
                    fontSize: { xs: "1.2rem", sm: "0.95rem", md: "0.9rem" },
                    lineHeight: 1.35,
                    background:
                      "linear-gradient(110deg, rgba(255, 214, 198, 0.8) 0%, rgba(255, 214, 198, 0.8) 38%, rgba(255, 242, 236, 1) 50%, rgba(255, 214, 198, 0.8) 62%, rgba(255, 214, 198, 0.8) 100%)",
                    backgroundSize: "320% 100%",
                    backgroundPosition: "240% 0",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    color: "transparent",
                    WebkitTextFillColor: "transparent",
                    filter: "drop-shadow(0 0 4px rgba(255, 158, 128, 0.55))",
                    animation:
                      "niAuthorLineShine 1.6s linear infinite, niAuthorLinePulse 1.6s ease-in-out infinite",
                    "@keyframes niAuthorLineShine": {
                      "0%": { backgroundPosition: "240% 0" },
                      "100%": { backgroundPosition: "-140% 0" },
                    },
                    "@keyframes niAuthorLinePulse": {
                      "0%, 100%": {
                        filter: "drop-shadow(0 0 4px rgba(255, 158, 128, 0.55))",
                        textShadow: "0 0 3px rgba(255, 176, 152, 0.45)",
                        opacity: 0.9,
                      },
                      "50%": {
                        filter: "drop-shadow(0 0 12px rgba(255, 198, 180, 0.95))",
                        textShadow: "0 0 10px rgba(255, 228, 220, 0.9), 0 0 20px rgba(255, 166, 138, 0.6)",
                        opacity: 1,
                      },
                    },
                  }}
                >
                  Native Intelligence for Authoring Structured Engineering Content
                </Typography>

                {/* factory illustration */}
                {/* <Box sx={{ mt: 2 }}>
                  <Box component="img" src="/Factory4.png" alt="Factory" sx={{ height: 220, objectFit: "contain" }} />
                </Box> */}

                <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
                  <Box component="img" src="/customerlogo.jpeg" alt="Customer Logo" sx={{ maxHeight: 170, width: "auto", objectFit: "contain" }} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Container>

      <Dialog open={requestAccessOpen} onClose={() => setRequestAccessOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Register to Access Fiorentinispa Parts Catalogue</DialogTitle>
        <Box component="form" onSubmit={handleRequestAccess}>
          <DialogContent sx={{ display: "grid", gap: 2, pt: 1 }}>
            <TextField
              label="Vendor Name"
              value={vendorName}
              onChange={(e) => setVendorName(e.target.value)}
              required
              fullWidth
            />
            <TextField
              label="Contact Email"
              type="email"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
              fullWidth
            />
            <TextField
              label="Phone Number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              fullWidth
            />
            <TextField
              select
              label="Country"
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
              fullWidth
              required
            >
              {countryOptions.map((country) => (
                <MenuItem key={country.code} value={country.code}>
                  {country.name}
                </MenuItem>
              ))}
            </TextField>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={() => setRequestAccessOpen(false)} disabled={requestAccessLoading}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" disabled={requestAccessLoading}>
              {requestAccessLoading ? "Submitting..." : "Submit Request"}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ position: "fixed", top: "20px", left: "50%", transform: "translateX(-50%)", zIndex: 9999 }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} variant="filled" sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
